/*!

=========================================================
* Black Dashboard React v1.0.0
=========================================================

* Product Page: /product/black-dashboard-react
* Copyright 2019 SecurePoint 360 ()
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by SecurePoint 360

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import TableWithStickyHeader from 'components/TableWithStickyHeader';
import moment from 'moment';
import React from 'react';

// reactstrap components
import { MagicSpinner } from 'react-spinners-kit';
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';

import NoRecordFound from '../../components/NoRecordFound/NoRecordFound';
import { verifyAccessToken } from '../../lib/auth';
import axios from '../../lib/axiosInstance';

class CompanyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      modal: false,
      currentReport: {},
      currentData: {},
      tagData: [],
      searchValue: '',
      currentTag: {},
      selectedTags: [],
      company_search_data: '',
      openModal: false,
      loader: true,
      currentPage: 0,
      ordering: 'report_id',
    };
  }
  orderBy(target) {
    let field = target;
    if (this.state.ordering === field) {
      field = '-' + field;
    }
    this.setState({ ordering: field });
    let self = this;
    setTimeout(function () {
      self.fetchCompanies();
    }, 60);
  }
  renderLoader() {
    if (this.state.loader === true) {
      return (
        <section className="loader-section">
          <MagicSpinner size={60} color="#0665a9" loading={this.state.loader} />
        </section>
      );
    }
  }
  toggle() {
    let modal = this.state.modal;
    this.setState({ modal: !modal });
  }
  componentDidMount() {
    this.fetchCompanies.bind(this)();
    localStorage.setItem('last_path', window.location.pathname);
  }
  async fetchCompanies(currentUrl, currentPage) {
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/companies/?search=' + this.state.company_search_data,
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    if (currentUrl) {
      url = currentUrl;
    }
    url += '&ordering=' + this.state.ordering;
    if (currentPage !== undefined) {
      this.setState({ currentPage: currentPage });
    } else {
      this.setState({ currentPage: 0 });
    }
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              reports: res.data.results,
              count: res.data.count,
              loader: false,
              nextUrl: res.data.next
                ? '/companies/?' + res.data.next.split('?')[1]
                : null,
              previousUrl: res.data.previous
                ? '/companies/?' + res.data.previous.split('?')[1]
                : null,
            });
          } else {
            this.setState({ reports: [], count: 0 });
          }

          this.setState({ modal: false });
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }
  async fetchCompaniesFromQualys() {
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/qualys/reports/latest/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      },
      data = {};
    await axios
      .post(url, data, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              reports: res.data.results,
              count: res.data.count,
              loader: false,
              nextUrl: res.data.next
                ? '/companies/?' + res.data.next.split('?')[1]
                : null,
              previousUrl: res.data.previous
                ? '/companies/?' + res.data.previous.split('?')[1]
                : null,
            });
          } else {
            this.setState({ reports: [], count: 0 });
          }

          this.setState({ modal: false });
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }
  async fetchReportDetail(id) {
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/reports/' + id + '/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            this.setState({
              currentReport: res.data,
              loader: false,
              modal: true,
            });
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      });
  }
  async downlaodReport(id) {
    await verifyAccessToken();
    let url = '/companies/' + id + '/download/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    this.setState({ loader: true });
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ loader: false });
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            // let currentData = res.data
            const url = res.data['signed_url'];
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `sample.${this.state.file}`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }
  async copyDownlaodReport(id) {
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/companies/' + id + '/generate-signed-url/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            // let currentData = res.data
            let copyText = res.data['signed_url'];
            var textField = document.createElement('textarea');
            textField.value = copyText;
            document.body.appendChild(textField);
            textField.select();
            document.execCommand('copy');
            /* Alert the copied text */
            // alert("Copied the url: " + textField.value);
            this.setState({
              openModal: true,
              is_success: true,
              loader: false,
              modalDetail: textField.value,
              modalTitle: 'Link Coppied!',
            });
            document.body.removeChild(textField);
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }

  renderNextUrl() {
    if (this.state.nextUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            next
            onClick={() =>
              this.fetchCompanies(
                this.state.nextUrl +
                  '&search=' +
                  this.state.company_search_data,
              )
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPreviousUrl() {
    if (this.state.previousUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            previous
            onClick={() =>
              this.fetchCompanies(
                this.state.previousUrl +
                  '&search=' +
                  this.state.company_search_data,
              )
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPages() {
    let pages = [];
    let pageCount = Math.ceil(this.state.count / 25.0),
      currentPage = this.state.currentPage;
    let leftPages = pageCount > 10 ? (currentPage > 8 ? 6 : 10) : pageCount;
    let midPages = currentPage > 8 ? 3 : 0;
    let rightPages = pageCount - leftPages;
    for (let index = 0; index < leftPages; index++) {
      let url =
        '/companies/?search=' +
        this.state.company_search_data +
        '&limit=25&offset=' +
        parseInt(25 * index);
      pages.push(
        <PaginationItem
          className={this.state.currentPage === index ? 'active' : ''}
        >
          <PaginationLink onClick={() => this.fetchCompanies(url, index)}>
            {index + 1}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    if (midPages > 1) {
      pages.push(<PaginationItem className="more-pages">...</PaginationItem>);
    }
    for (let index = 0; index < midPages; index++) {
      let pageIndex = index - 1 + currentPage;
      if (pageIndex < pageCount - 1) {
        let url =
          '/companies/?search=' +
          this.state.company_search_data +
          '&limit=25&offset=' +
          parseInt(25 * pageIndex);
        pages.push(
          <PaginationItem
            className={this.state.currentPage === pageIndex ? 'active' : ''}
          >
            <PaginationLink onClick={() => this.fetchCompanies(url, pageIndex)}>
              {pageIndex + 1}
            </PaginationLink>
          </PaginationItem>,
        );
      }
    }
    if (rightPages > 1 && pageCount - 3 > currentPage) {
      pages.push(<PaginationItem className="more-pages">...</PaginationItem>);
    }
    if (rightPages >= 1) {
      let url =
        '/companies/?search=' +
        this.state.company_search_data +
        '&limit=25&offset=' +
        parseInt(25 * (pageCount - 1));
      pages.push(
        <PaginationItem
          className={this.state.currentPage === pageCount - 1 ? 'active' : ''}
        >
          <PaginationLink
            onClick={() => this.fetchCompanies(url, pageCount - 1)}
          >
            {pageCount}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    // }
    return (
      <>
        {pages.map((item, index) => {
          return item;
        })}
      </>
    );
  }
  renderPagination() {
    let pageCount = Number(this.state.count / 25.0);
    if (pageCount > 1)
      return (
        <>
          <Pagination aria-label="Page navigation example">
            {this.renderPreviousUrl()}
            {this.renderPages()}
            {this.renderNextUrl()}
          </Pagination>
        </>
      );
  }
  oepnMemeberModal(id) {
    this.setState({ createModal: true, current_company_id: id });
  }
  renderButton(data) {
    // if(data.report_status === 'COMPLETE'){
    let disable_download = data['active_reports'] === 0 ? true : false;
    return (
      <>
        <Button
          color="primary"
          outline
          size="sm"
          title={'Add member'}
          onClick={() => this.oepnMemeberModal.bind(this)(data.id)}
        >
          <i className="fa fa-plus"></i>
        </Button>
        <Button
          color="primary"
          outline
          size="sm"
          title={'Download report'}
          disabled={disable_download}
          onClick={() => this.downlaodReport.bind(this)(data.id)}
        >
          <i className="tim-icons icon-cloud-download-93"></i>
        </Button>
        <Button
          color="primary"
          outline
          size="sm"
          title={'Copy report link'}
          disabled={disable_download}
          onClick={() => this.copyDownlaodReport.bind(this)(data.id)}
        >
          <i className="fa fa-clipboard "></i>
        </Button>
      </>
    );
  }
  renderReportList() {
    let reports = this.state.reports; //,
    // data = []
    return (
      <>
        {reports.map((data, idx) => {
          let members = data['members_list'],
            membersString = '';
          members.map((memberData) => {
            membersString += memberData[2] + ', ';
          });
          return (
            // <th>ID</th>
            // <th>Name</th>
            // <th>Active Reports</th>
            // <th>Total Reports</th>
            // <th>Creation Date</th>
            // <th>Owner</th>
            // <th>Members</th>
            // <th className="text-right">
            // </th>
            <tr>
              <td>{data['id']}</td>
              <td>
                {data['display_name'] ? data['display_name'] : data['name']}
              </td>
              <td>{data['active_reports']}</td>
              <td>{data['total_reports']}</td>
              <td>{moment(data['updated_at']).format('lll')}</td>
              <td>{data['user__email']}</td>
              <td>{membersString}</td>
              <td className="text-right">
                {this.renderButton.bind(this)(data)}
              </td>
            </tr>
          );
        })}
      </>
    );
  }
  async onTagChange(data) {
    this.setState({ company_search_data: data });
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/companies/?search=' + data,
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    await axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ loader: false });
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              reports: res.data.results,
              count: res.data.count,
              nextUrl: res.data.next
                ? '/companies/?' + res.data.next.split('?')[1]
                : null,
              previousUrl: res.data.previous
                ? '/companies/?' + res.data.previous.split('?')[1]
                : null,
            });
          } else {
            this.setState({ reports: [], count: 0 });
          }

          this.setState({ modal: false });
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        let res = err.response;
        this.setState({ loader: false });
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }
  async addTag(id) {
    let selectedTagIds = this.state.selectedTagIds || [];
    selectedTagIds.push(id);
    this.setState({ selectedTagIds: selectedTagIds, showDropdown: false });
    await verifyAccessToken();
    let url = '/tags/?id=' + id,
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    axios
      .get(url, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            let currentData = res.data.results;
            //console.log('CurrentData', currentData)
            this.setState({ tagData: currentData });

            if (res.data.count === 1) {
              let selectedTags = this.state.selectedTags;
              selectedTags.push(currentData[0]);
              this.setState({
                currentTag: currentData[0],
                selectedTags: selectedTags,
              });
            }
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }
  renderNotification() {
    // const [open, setOpen] = React.useState(true);
    return (
      <>
        <Collapse in={this.state.openModal === true}>
          <Alert
            severity={this.state.is_success === true ? 'success' : 'error'}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  this.setState({ openModal: false });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle>{this.state.modalTitle}</AlertTitle>
            {this.state.modalDetail}
          </Alert>
        </Collapse>
      </>
    );
  }
  async addMember() {
    let data = {
      email: this.state.email,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      company: this.state.current_company_id,
    };
    this.setState({ loader: true });
    await verifyAccessToken();
    let url = '/profiles/',
      headers = {
        Authorization: 'Bearer ' + localStorage.getItem('access'),
      };
    await axios
      .post(url, data, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          this.setState({
            loader: false,
            createModal: false,
            openNotificationModal: true,
            modalDetail: 'Member has been successfully added to your company.',
            modalTitle: 'Success!',
            openModal: true,
            is_success: true,
          });
          this.fetchCompanies();
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        }
      });
  }
  createToggle() {
    let createModal = this.state.createModal;
    this.setState({ createModal: !createModal });
  }
  renderCreateModal() {
    // let company_id = this.state.current_company_id
    return (
      <Modal
        isOpen={this.state.createModal}
        toggle={this.createToggle.bind(this)}
        size="lg"
      >
        <ModalHeader toggle={this.createToggle.bind(this)}>
          Add Member
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col xs="12" sm="6">
              <TextField
                variant="outlined"
                margin="normal"
                required={true}
                fullWidth
                id="first_name"
                type="text"
                label="First Name"
                name="first_name"
                autoComplete="first_name"
                autoFocus
                onChange={(element) => {
                  this.setState({ first_name: element.target.value });
                }}
              />
            </Col>
            <Col xs="12" sm="6">
              <TextField
                variant="outlined"
                margin="normal"
                required={true}
                fullWidth
                id="last_name"
                type="text"
                label="Last Name"
                name="last_name"
                autoComplete="last_name"
                autoFocus
                onChange={(element) => {
                  this.setState({ last_name: element.target.value });
                }}
              />
            </Col>
            <Col xs="12" sm="12">
              <TextField
                variant="outlined"
                margin="normal"
                required={true}
                fullWidth
                id="email"
                type="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={(element) => {
                  this.setState({ email: element.target.value });
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => this.createToggle.bind(this)()}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={() => this.addMember.bind(this)()}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
  render() {
    let tagData = this.state.tagData;
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="7" sm="12">
                      <h4>
                        Reports{' '}
                        {this.state.currentTag.name
                          ? 'for ' + this.state.currentTag.name
                          : ''}
                      </h4>
                    </Col>
                    <Col md="5" sm="12" className="text-right">
                      <Row>
                        <Col md="12" sm="12" className="text-right">
                          <Input
                            type="text"
                            list="data"
                            style={{ marginTop: '9px' }}
                            value={this.state.searchValue}
                            placeholder="Search Company"
                            onChange={(e) => {
                              this.setState({
                                searchValue: e.target.value,
                                showDropdown: true,
                              });
                              this.onTagChange(e.target.value);
                            }}
                          />

                          <Row
                            className=""
                            style={{
                              marginLeft: '0px',
                              marginRight: '0px',
                              position: 'absolute',
                              display:
                                this.state.showDropdown === true ? '' : 'none',
                              zIndex: 4,
                              background: '#FFFFFF',
                              border: '1px solid #CCCCCC',
                              width: 'calc(-30px + 100%)',
                              boxShadow: '3px 3px 10px #cccccc',
                              cursor: 'pointer',
                            }}
                          >
                            {tagData.map((item, key) => (
                              <Col
                                sm="12"
                                key={key}
                                onClick={(e) => this.addTag(item.id)}
                                style={{
                                  textAlign: 'left',
                                  padding: 5,
                                }}
                              >
                                {item.name}
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardHeader>
                {this.state.reports.length == 0 && <NoRecordFound />}
                {this.state.reports.length != 0 && (
                  <CardBody>
                    <TableWithStickyHeader>
                      <thead className="text-primary">
                        <tr className="thead">
                          <th
                            onClick={() => {
                              this.orderBy('id');
                            }}
                          >
                            ID{' '}
                            <i
                              className={
                                this.state.ordering === 'id'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-id'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('display_name');
                            }}
                          >
                            Name{' '}
                            <i
                              className={
                                this.state.ordering === 'display_name'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-display_name'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('active_reports');
                            }}
                          >
                            Active Reports{' '}
                            <i
                              className={
                                this.state.ordering === 'active_reports'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-active_reports'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('total_reports');
                            }}
                          >
                            Total Reports{' '}
                            <i
                              className={
                                this.state.ordering === 'total_reports'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-total_reports'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('updated_at');
                            }}
                          >
                            Updated At{' '}
                            <i
                              className={
                                this.state.ordering === 'updated_at'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-updated_at'
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th>Owner</th>
                          <th>Members</th>
                          <th className="text-right"></th>
                        </tr>
                      </thead>
                      <tbody>{this.renderReportList.bind(this)()}</tbody>
                    </TableWithStickyHeader>
                  </CardBody>
                )}
                <CardFooter>{this.renderPagination.bind(this)()}</CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderNotification()}
        {this.renderLoader()}
        {this.renderCreateModal()}
      </>
    );
  }
}

export { CompanyList };
